import { BOToothQuoteDetailFace } from "./BOToothQuoteDetailFace.model";

export class BOToothQuoteDetail{
  id:number;
  toothQuoteId:number;
  toothTypeId:number;
  patientId:number;
  patientDocumentId?:number;
  patientDocumentIdString?:string;
  date?:Date;
  odontogramaId?:number;
  clinicHistoryId?:number;
  fixed?:boolean;
  observations?:string;
  treatment?:string;
  price:number;
  comodin?:string;
  toothTypeIdString?:string;
  toothFaces?:BOToothQuoteDetailFace[]=[];

}
